"use client";

import type { getNeedleItemsFromSizes } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import Image from "next/image";
import { Counter } from "~/components/ui/Counter";
import type { useQuantityInput } from "~/components/ui/VariantPicker/hooks/useQuantityInput";
import { useCurrency } from "~/lib/hooks/useCentra";
import { usePrice } from "~/lib/hooks/usePrice";
import styles from "./NeedleCartItem.module.css";

export type TNeedles = {
	items: NeedleCartItem[];
	recommendationText: string;
};

export type NeedleCartItem = ReturnType<typeof getNeedleItemsFromSizes>[number];

export type TCartItemWithQuantity = NeedleCartItem & {
	quantityInput: ReturnType<typeof useQuantityInput>[number];
};

export const NeedleCartItem = ({ item }: { item: TCartItemWithQuantity }) => {
	const { price, priceAsNumber } = usePrice({
		pricelist: item.pricelist,
	});
	const { data: currency } = useCurrency();

	return (
		<div className={clsx(styles["cart-item-container"])}>
			<div className={clsx(styles["cart-item-details"])}>
				<div className={styles["cart-image-wrapper"]}>
					<span className={clsx(styles["cart-item-image"])}>
						{item?.firstThumbnail && <Image src={item?.firstThumbnail} fill alt="" />}
					</span>
				</div>
				<div className={clsx(styles["cart-item-info"])}>
					<p className={clsx(styles["cart-item-name"])}>{item.name} </p>
					<p className={styles["cart-item-detail"]}>
						{item.needle} / {item?.length}
					</p>
					<p className={styles["cart-item-price"]}>{price} </p>
				</div>
			</div>
			<div className={clsx(styles["cart-item-summary"])}>
				<Counter {...item.quantityInput} />
				<div className={styles["cart-item-lineprice"]}>
					{(priceAsNumber || 0) * item?.quantityInput?.value} {currency}
				</div>
			</div>
		</div>
	);
};
